import { render, staticRenderFns } from "./RecipientDeleteReason.vue?vue&type=template&id=363f2e60"
import script from "./RecipientDeleteReason.vue?vue&type=script&lang=js"
export * from "./RecipientDeleteReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports